import { MenuCategoriesProps, SelectedMenus, template3PlaceholderData, TemplateProps } from '@zeus/shared';
import useFont from '../../../hooks/useFont';
import { forwardRef } from 'react';
import Menu from './components/menu';
import { getScaleSize } from '../../../utils/utils';
import { useNormalizedPixels } from '../../../hooks/useResize';
import Media from '../Media';
import { BoxComponent } from '../../../base/box/Box';
import { TypographyComponent } from '../../../base/typography/Typography';

export const Template3 = forwardRef<HTMLDivElement, TemplateProps>((props, ref) => {
  const { template, scale = 1, development, style, timezone, tenantId, templateRef, active, shouldLoad = true } = props;

  useFont(template?.fontFamily);
  const { normalizePixels } = useNormalizedPixels();

  const bgStyles = () => {
    if (template?.background?.isEnabled && template?.background?.image) {
      return { backgroundImage: `url(${template?.background?.image})` };
    }

    if (template?.background?.color) {
      return { backgroundColor: template?.background?.color };
    }

    return {
      backgroundImage: `url(https://dashboard-demo-assests.s3.us-west-2.amazonaws.com/dashboard/menuboard/Template3.webp)`,
    };
  };

  const menus: SelectedMenus[] =
    Array.isArray(template?.content) && template?.content?.length > 0 ? template.content : template3PlaceholderData;
  const { content: templateContent, ...rest } = template;
  const media = template?.media?.mediaContent;
  const isMedia = template?.media?.isEnabled && media?.url;
  const isLayoutOne = isMedia && template.layoutType === 1;

  const filteredMenus = menus
    .filter((menu: SelectedMenus) => menu.categories && menu.categories.length > 0) // Filter menus that have categories
    .map((menu: SelectedMenus) => ({
      ...menu,
      categories: menu.categories.map((category: MenuCategoriesProps, index: number) => ({
        ...category,
        index,
      })),
    }));

  return (
    <div
      ref={templateRef}
      style={{
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        position: 'relative',
        padding: isLayoutOne
          ? '0px'
          : `${getScaleSize(normalizePixels(50, 'height'), scale)} ${getScaleSize(
              normalizePixels(50, 'width'),
              scale
            )}`,
        ...bgStyles(),
        ...(!style ? { height: '100vh', width: '100vw' } : style),
      }}
    >
      {isLayoutOne && (
        <section
          id="temp3-layout-1-image"
          style={{
            width: '34%',
            order: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            left: '33%',
          }}
        >
          <Media
            isDevelopment={development}
            media={media}
            height={'100%'}
            borderRadius="0px"
            playing={active}
            shouldLoad={shouldLoad}
          />
        </section>
      )}
      <div
        ref={ref}
        id="container"
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: isLayoutOne && filteredMenus[0]?.categories?.length > 0 ? 'space-between' : 'center',
          overflow: 'hidden',
          padding: isLayoutOne
            ? `${getScaleSize(normalizePixels(50, 'height'), scale)} ${getScaleSize(
                normalizePixels(50, 'width'),
                scale
              )}`
            : '0px',
        }}
      >
        {Array.isArray(filteredMenus) &&
          filteredMenus.length > 0 &&
          filteredMenus.map((menu, menuIndex) => (
            <Menu
              key={menu.id}
              menu={menu}
              menuIndex={menuIndex}
              template={rest}
              development={development}
              timezone={timezone}
              scale={scale}
              tenantId={tenantId}
              active={active}
              shouldLoad={shouldLoad}
            />
          ))}
      </div>

      {template.taxLabel.isEnabled && (
        <BoxComponent
          sx={{ position: 'absolute', left: getScaleSize(normalizePixels(50, 'width'), scale), bottom: '1%' }}
        >
          <TypographyComponent
            sx={{ color: '#fff', fontWeight: '500', fontSize: normalizePixels(12, 'height') }}
            variant="subtitle1"
          >
            {template.taxLabel.taxText}
          </TypographyComponent>
        </BoxComponent>
      )}
    </div>
  );
});
